import { HideOutlineIcon, ObjectIcon } from '@carboncopyco/icons';
import type { TableCraftObject } from '@carboncopyco/types';
import { ModificationItem } from '../ModificationItem';
import {
  RuleCardDropdown,
  type RuleItemConfig,
  RulesContent,
} from '../RulesManager';
type ObjectManagerContentProps = {
  selectedObject: TableCraftObject;
  tableCraftObjects: TableCraftObject[];
  onObjectClick: (id: TableCraftObject['structure_sha']) => void;
  onObjectHide: (id: TableCraftObject['structure_sha'], hide: boolean) => void;
};

export const ObjectsManagerContent = ({
  selectedObject,
  tableCraftObjects,
  onObjectClick,
  onObjectHide,
}: ObjectManagerContentProps) => {
  return (
    <RulesContent>
      <RulesContent.List<TableCraftObject>
        reverseRules={false}
        draggable={false}
        rules={tableCraftObjects.map((item) => ({
          id: item.structure_sha,
          rule: item,
        }))}
        renderItem={({
          ruleItem,
        }: {
          ruleItem: RuleItemConfig<TableCraftObject>;
        }) => {
          const item = ruleItem.rule;

          return (
            <RulesContent.List.Item
              selected={selectedObject?.structure_sha === item.structure_sha}
              expandable={false}
              id={ruleItem.id}
              onClick={() => {
                onObjectClick(item.structure_sha);
              }}
              aria-label={item.display_name}
              header={
                <ModificationItem>
                  <ModificationItem.Content>
                    <ModificationItem.Icon
                      borderColor={
                        item.is_modified ? 'border-ds-primary-300' : undefined
                      }
                    >
                      <ObjectIcon size={18} />
                    </ModificationItem.Icon>
                    <ModificationItem.Text label={item.display_name} />
                  </ModificationItem.Content>
                </ModificationItem>
              }
              action={
                <RuleCardDropdown
                  items={[
                    {
                      type: 'hide',
                      label: 'Hide Table',
                      iconLeft: <HideOutlineIcon size={20} />,
                      onClick: () => {
                        onObjectHide(item.structure_sha, true);
                        return;
                      },
                    },
                  ]}
                  zIndex={200}
                />
              }
            />
          );
        }}
      />
    </RulesContent>
  );
};
